module.exports = __webpack_public_path__ + "static/media/Restrooms-c-f.12d653ef.webp";